/**
 * Which of its states the row of Concierge cards under the profile header is
 * in. The Next Best Action (CT-5713) and How to approach (CT-5714) are both fed
 * by the Concierge, so these states belong to the PAIR. One value, the same
 * shape as `traitsListState` / `insightsListState`.
 */
export const SUMMARY_STATE = Object.freeze({
  /** Either card is on its way. */
  LOADING: 'loading',
  /** Either failed → ONE compact "Couldn't load suggestions · Retry" row. */
  ERROR: 'error',
  /** No suggestion and nothing to say → ONE line "No suggestions right now · checked <time>". */
  EMPTY: 'empty',
  /** Whichever cards have content (alone, a card takes the full width). */
  CARDS: 'cards',
});

/**
 * @param {object} sources
 * @param {{ loading: boolean, error: unknown, items: object[] }} sources.nba
 * @param {{ loading: boolean, error: unknown, approach: { fields?: object[] } | null }} sources.approach
 */
export const summaryState = ({ nba, approach }) => {
  if (nba.loading || approach.loading) return SUMMARY_STATE.LOADING;
  if (nba.error || approach.error) return SUMMARY_STATE.ERROR;
  if (!nba.items?.length && !approach.approach?.fields?.length) return SUMMARY_STATE.EMPTY;
  return SUMMARY_STATE.CARDS;
};

/** Collapse folds the cards, and stays offered on the error row as in the prototype. */
export const canCollapseSummary = (state) => state === SUMMARY_STATE.CARDS || state === SUMMARY_STATE.ERROR;
